// Marks THIS browser as belonging to WG staff, so preview-link views from it
// don't inflate a client's engagement stats.
//
// Why a browser flag rather than another URL parameter: IP allowlisting
// (staff_view_ips) only suppresses views from a known address, which misses
// staff on home broadband or a phone. A `?staff=1` style marker would fix the
// reach but travels with the link — forward that URL to the customer once and
// their visits silently stop counting forever. The admin console is already
// behind a staff login, so setting the flag there uses authentication as the
// gate and nothing leaks into a shareable URL.
//
// The opt-out key exists because the admin console marks the browser on every
// load. Without it, a staff member who deliberately unmarks to see a preview
// the way a customer does would be silently re-marked the next time they
// opened the admin page.
//
// Every accessor is wrapped: localStorage throws in private mode and in some
// embedded webviews, and a failure to read this should never break a preview.

const KEY = 'wg_staff_viewer'
const OPT_OUT = 'wg_staff_viewer_optout'

export function markStaffViewer() {
  try {
    localStorage.setItem(KEY, '1')
    localStorage.removeItem(OPT_OUT)
  } catch { /* private mode — fall back to IP suppression */ }
}

// Deliberate unmark: also records the opt-out so autoMarkStaffViewer() leaves
// this browser alone until it's marked again explicitly.
export function clearStaffViewer() {
  try {
    localStorage.removeItem(KEY)
    localStorage.setItem(OPT_OUT, '1')
  } catch { /* nothing to do */ }
}

export function isStaffViewer() {
  try { return localStorage.getItem(KEY) === '1' } catch { return false }
}

// Called when the admin console loads. Reaching it requires a staff login,
// so that's sufficient proof — unless they've opted out on purpose.
export function autoMarkStaffViewer() {
  try {
    if (localStorage.getItem(OPT_OUT) === '1') return false
  } catch { return false }
  markStaffViewer()
  return true
}
